import { useEffect, useState } from "react";
import {
  CheckCircleIcon,
  EllipsisHorizontalCircleIcon,
} from "@heroicons/react/24/solid";

export default function StepLabel({
  title = "Step X",
  description = "Some Description",
  current = "current", // 'current', 'past', or anything else
  onClick = () => {},
}) {
  const [color, setColor] = useState("black");
  const [borderColor, setBorderColor] = useState("lightgray");

  useEffect(() => {
    switch (current) {
      case "current":
        setColor("var(--secondary-color)");
        setBorderColor("var(--secondary-color)");
        break;
      case "past":
        setColor("var(--primary-color)");
        setBorderColor("var(--primary-color)");
        break;
      default:
        setColor("black");
        setBorderColor("lightgray");
        break;
    }
  }, [current]);

  const renderIcon = () => {
    switch (current) {
      case "current":
        return (
          <EllipsisHorizontalCircleIcon
            className="w-5 h-5 mr-2 text-[color:var(--secondary-color)]"
            aria-hidden="true"
          />
        );
      case "past":
        return (
          <CheckCircleIcon
            className="w-5 h-5 mr-2 text-[color:var(--primary-color)]"
            aria-hidden="true"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      className="flex flex-col border-b-4 px-2 py-1 w-full cursor-pointer transition-opacity hover:opacity-90 focus:outline-none"
      style={{ borderColor: borderColor }}
    >
      <div className="flex items-center">
        {renderIcon()}
        <h2 className="font-semibold" style={{ color }}>
          {title}
        </h2>
      </div>
      <p className="text-sm font-light text-black/40">{description}</p>
    </div>
  );
}
